import React from 'react';
import Scroll from 'react-scroll';
import Select from 'react-select';

import Const from '../../util/Constants';
import RegEx from '../../util/RegEx';
import FieldController from '../../controller/FieldController';

class FieldMultiSelect extends React.Component {
  
  constructor(props) {
    super(props);
    if(props.field) {
      this.visible = props.field.visible === Const.True;
      this.editable = props.field.editable === Const.True;
      this.LabelName = props.field.label_name;
      this.regex = props.field.validate;
      this.Key = props.id;
      this.options = [];
      if(props.fieldOption && props.fieldOption[this.Key]) {
        this.options = props.fieldOption[this.Key];
      } else {
        this.options = FieldController.getOptions(props.field);
      }
      const values = this.props.value ? this.props.value: '';
      this.selections = this.options.filter(opt => values.includes(Const.Opt+opt.value+Const.Opt));
      this.state = { selections: this.selections, inValid: {} };
    } else {
      this.visible = false;
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    const visible = props.field.visible === Const.True;
    const editable = props.field.editable === Const.True;
    let options = [];
    if(props.fieldOption && props.fieldOption[this.Key]) {
      options = props.fieldOption[this.Key];
    } else {
      options = FieldController.getOptions(props.field);
    }
    if(visible !== this.visible || editable !== this.editable || this.props.value !== props.value
      || this.options !== options) {
      this.visible = props.field.visible === Const.True;
      this.editable = props.field.editable === Const.True;
      this.LabelName = props.field.label_name;
      this.regex = props.field.validate;
      this.Key = props.id;
      const values = props.value ? props.value: '';
      this.options = options;
      const selections = this.options.filter(opt => values.includes(Const.Opt+opt.value+Const.Opt));
      this.setState({ ...this.state, selections, inValid: {} });
    }
  }

  onChange = (selections) => {
    let value  = '';
    for(let i = 0; i < selections.length; i++) { value = value + selections[i].value + '~'; }
    value = value !== '' ? '~' + value : '';
    let inValid = { };
    if(!RegEx.isDate(value, this.regex)) inValid[this.Key] = 'Invalid Data';
    this.props.onValueChange(this.Key, value);
    this.setState({ selections: selections, inValid: { ...inValid } });
  }

  render() {
    if(!this.visible || !this.editable) return null;
    
    let inValid = this.state.inValid;
    if(this.editable && RegEx.isKeyPresent(this.props.inValid, this.Key)) {
      inValid = this.props.inValid;
    }

    let multi = false;
    try {
      multi = this.props.field.validate ? !JSON.parse(this.props.field.validate).multi : false;
    } catch(err) {
      console.log(err);
    }
    
    return (
      <div className="col">
        <div className={`form-group ${RegEx.class(inValid, this.Key)}`}>
          <Scroll.Element name={this.Key} />
          <label>{this.LabelName}</label> {RegEx.showError(inValid, this.Key)}
          <Select 
            value={this.state.selections} 
            onChange={this.onChange}
            options={this.options} 
            isDisabled={!this.editable} 
            isSearchable={true}
            isClearable={true} 
            isMulti={true}
            isOptionDisabled={() => multi ? this.state.selections.length >= 1 : multi } />
        </div>
      </div>
    );
  }
}
export default FieldMultiSelect;